import React from 'react';
import './index.css';
import './Bootstrap/css/bootstrap.css';
import Navbar from './Navbar';


export default function Home() {
	return (
		<div className="container-md">
			<Navbar />
			
			<div className="container hero-banner" style={{backgroundImage: "url('/image/blue.png')", textAlign: "center"}}>
				<div className="hero-title h1">Do One Thing, Do It Perfectly.</div>
				{/* <Link to="/career">
					<button className="btn btn-lg" style={{color: "#2556A6", backgroundColor: "#EAEEF7", border: "1px solid #2556A6"}}>Find Jobs</button>
				</Link> */}
			</div>
			
			<h2 className="title">About Us</h2>
			<hr />
			<div className="row" style={{marginTop: "20px"}}>
				<div className="col-sm-5">
					<img src="/image/about_us.jpg" style={{width: "95%", marginLeft: "10px"}} alt="consulting group"/>
				</div>
				
				<div className="col-sm-7 content">
					<p className="h4">We are a technology consulting firm dedicated to delivering high-quality software solutions that help organizations thrive. With over 
						10 years of consulting experience in the financial industry and public sector, we understand the demands of complex, high-stakes environments. 
						Our services span the full software development life cycle, including front-end design, back-end microservices, database development, 
						and cloud architecture. We combine deep technical expertise with a collaborative, client-focused approach—ensuring that every solution 
						we deliver is scalable, secure, and aligned with our clients’ long-term goals.</p>
					
				</div>
			</div>
			
			<h2 className="title">Our Mission</h2>
			<hr />
			<div className="row content" style={{marginTop: "20px", marginLeft: "10px"}}>			
				<div className="col-sm-9">
					<p className="h4" >Our mission is to empower people and organizations to innovate with confidence. We partner closely with our clients 
						to transform ideas into impactful, forward-thinking software solutions. By combining deep technical expertise with a collaborative, 
						human-centered approach, we help businesses navigate change, embrace emerging technologies, and stay ahead in a rapidly evolving 
						digital landscape. Innovation isn’t just what we deliver—it’s how we think, work, and grow together.</p>
				</div>
				<div className="col-sm-3">
					<img src="/image/mission.png" style={{width: "50%", marginLeft: "20px"}} alt="mission icon"/>
				</div>
			</div>
			
			<h2 className="title">Our Culture</h2>
			<hr />
			<div className="row" style={{marginTop: "20px", marginLeft: "10px"}}>		
				<div className="col-sm-3">
					<img src="/image/culture.jpg" style={{width: "60%", marginLeft: "20px"}} alt="culture icon"/>
				</div>
				<div className="col-sm-9 content">
					{/* <p className="h3" style={{fontWeight: "bold"}}>Do one thing, do it perfectly.</p> */}
					<p className="h4">We pride ourselves on doing one thing and doing it with precision, depth, and pride. Our culture is rooted in 
						technical excellence and laser-sharp focus. We aren’t trying to be everything to everyone; instead, we invest all our energy 
						into mastering the art and science of building high-quality software. From intuitive user interfaces to resilient microservices 
						and cloud-native infrastructure, every line of code we write reflects our commitment to doing things right. We value 
						craftsmanship, continuous improvement, and solving real problems with clean, scalable, and elegant solutions.</p>
				</div>
			</div>
			
			<h2 className="title">Our Value</h2>
			<hr />
			
			<div className="row content" style={{marginBottom: "20px"}}>
				<div className="col">
				  <div class="card" style={{backgroundColor: "#8fd3fe"}}>
					<div class="card-body text-center">
					  <h4 className="card-title" style={{fontSize: "26px", textDecoration: "underline", fontWeight: "bold"}}>Technical Excellene</h4>
					  <p class="card-text" style={{fontSize: "20px"}}>
						We take pride in delivering high-quality, well-engineered solutions using modern technologies and best practices.
					  </p>
					</div>
				  </div>
				</div>
				
				<div className="col">
				 <div class="card" style={{backgroundColor: "#b5e2ff"}}>
					<div class="card-body text-center">
					  <h4 className="card-title" style={{fontSize: "26px", textDecoration: "underline", fontWeight: "bold"}}>Client Partnership</h4>
					  <p class="card-text" style={{fontSize: "20px"}}>
						We work closely with our clients as trusted partners, aligning our work with their goals and long-term success.
					  </p>
					</div>
				  </div>
				</div>
				
				<div className="col">
				  <div class="card" style={{backgroundColor: "#daf0ff"}}>
					<div class="card-body text-center">
					  <h4 className="card-title" style={{fontSize: "26px", textDecoration: "underline", fontWeight: "bold"}}>Integrity & Accountability</h4>
					  <p class="card-text" style={{fontSize: "20px"}}>
						We are transparent, reliable, and fully accountable for the work we deliver.
					  </p>
					</div>
				  </div>
				</div>

				
				<div className="col">
				  <div class="card" style={{backgroundColor: "#daf0ff"}}>
					<div class="card-body text-center">
					  <h4 className="card-title" style={{fontSize: "26px", textDecoration: "underline", fontWeight: "bold"}}>Regulatory Awareness</h4>
					  <p class="card-text" style={{fontSize: "20px"}}>
						With deep experience in the financial and public sectors, we design and implement solutions that meet strict regulatory, security, and compliance standards.
					  </p>
					</div>
				  </div>
				</div>

			</div>
			
			<div className="container footer-bar">
				<p>© Copyright 2026 - DOTDIP Solutions Inc.</p>
			</div>
			
		</div>
	);
}
